import type { Product } from "@/core/infrastructure/services/ApiPaymentService";

// export class Order {
//     constructor(
//         public readonly id: string,
//         public readonly orderNo: number,
//         public readonly userId: string,
//         public readonly productName: string,
//         public readonly productId: string,
//         public readonly productPrice: number,
//         public readonly productAdjustedPrice: number,
//         public readonly productTotalPrice: number,
//         public readonly imageUrl: string | null,
//         public readonly merchantName: string,
//         public readonly shopName: string,
//         public readonly paymentType: PaymentType,
//         public readonly paymentPlan: PaymentPlan[],
//         public readonly planDuration: number,
//         public readonly planFrequency: string,
//         public readonly keepMyPrice: boolean,
//         public readonly keepMyPriceFee: number,
//         public readonly status: OrderStatus,
//         public readonly state: OrderState,
//         public readonly thirdPartyInitiated: boolean,
//         public readonly initiatePayment: boolean,
//         public readonly isRequested: boolean,
//         public readonly campaignId: string | null,
//         public readonly phoneNumber: string,
//         public readonly platform: string,
//         public readonly userName: string,
//         public readonly createdBy: string,
//         public readonly createdTime: Date,
//         public readonly updatedTime: Date
//     ) {
//     }

//     static create(params: OrderCreateParams): Order {
//         const orderNo = params.orderNo || Date.now();

//         return new Order(
//             params.id,
//             orderNo,
//             params.userId,
//             params.productName,
//             params.productId,
//             params.productPrice,
//             params.productAdjustedPrice || params.productPrice,
//             params.productTotalPrice || params.productPrice,
//             params.imageUrl || null,
//             params.merchantName,
//             params.shopName,
//             params.paymentType,
//             params.paymentPlan || [],
//             params.planDuration,
//             params.planFrequency,
//             params.keepMyPrice || false,
//             params.keepMyPriceFee || 0,
//             params.status || OrderStatus.PENDING,
//             params.state || OrderState.INITIATED,
//             params.thirdPartyInitiated || false,
//             params.initiatePayment || false,
//             params.isRequested || false,
//             params.campaignId || null,
//             params.phoneNumber,
//             params.platform,
//             params.userName,
//             params.createdBy,
//             params.createdTime || new Date(),
//             params.updatedTime || new Date()
//         );
//     }

//     updateStatus(status: OrderStatus, state?: OrderState): Order {
//         return new Order(
//             this.id,
//             this.orderNo,
//             this.userId,
//             this.productName,
//             this.productId,
//             this.productPrice,
//             this.productAdjustedPrice,
//             this.productTotalPrice,
//             this.imageUrl,
//             this.merchantName,
//             this.shopName,
//             this.paymentType,
//             this.paymentPlan,
//             this.planDuration,
//             this.planFrequency,
//             this.keepMyPrice,
//             this.keepMyPriceFee,
//             status,
//             state || this.state,
//             this.thirdPartyInitiated,
//             this.initiatePayment,
//             this.isRequested,
//             this.campaignId,
//             this.phoneNumber,
//             this.platform,
//             this.userName,
//             this.createdBy,
//             this.createdTime,
//             new Date()
//         );
//     }

//     updatePaymentPlan(paymentPlan: PaymentPlan[]): Order {
//         return new Order(
//             this.id,
//             this.orderNo,
//             this.userId,
//             this.productName,
//             this.productId,
//             this.productPrice,
//             this.productAdjustedPrice,
//             this.productTotalPrice,
//             this.imageUrl,
//             this.merchantName,
//             this.shopName,
//             this.paymentType,
//             paymentPlan,
//             this.planDuration,
//             this.planFrequency,
//             this.keepMyPrice,
//             this.keepMyPriceFee,
//             this.status,
//             this.state,
//             this.thirdPartyInitiated,
//             this.initiatePayment,
//             this.isRequested,
//             this.campaignId,
//             this.phoneNumber,
//             this.platform,
//             this.userName,
//             this.createdBy,
//             this.createdTime,
//             new Date()
//         );
//     }

//     getTotalAmount(): number {
//         return this.productTotalPrice + this.keepMyPriceFee;
//     }

//     getRemainingBalance(): number {
//         const paidAmount = this.paymentPlan
//             .filter(payment => payment.status === PaymentStatus.PAID)
//             .reduce((sum, payment) => sum + payment.amount, 0);

//         return this.getTotalAmount() - paidAmount;
//     }

//     getNextPaymentDue(): PaymentPlan | null {
//         const pendingPayments = this.paymentPlan
//             .filter(payment => payment.status === PaymentStatus.PENDING)
//             .sort((a, b) => a.dueDate.getTime() - b.dueDate.getTime());

//         return pendingPayments[0] || null;
//     }

//     isPaid(): boolean {
//         return this.paymentPlan.every(payment => payment.status === PaymentStatus.PAID);
//     }

//     isOverdue(): boolean {
//         const nextPayment = this.getNextPaymentDue();
//         return nextPayment ? nextPayment.dueDate < new Date() : false;
//     }

//     canBeCancelled(): boolean {
//         return [OrderStatus.PENDING, OrderStatus.CONFIRMED].includes(this.status);
//     }
// }

export enum OrderStatus {
    PENDING = 'pending',
    CONFIRMED = 'confirmed',
    PROCESSING = 'processing',
    SHIPPED = 'shipped',
    DELIVERED = 'delivered',
    CANCELLED = 'cancelled',
    REFUNDED = 'refunded'
}

export enum OrderState {
    INITIATED = 'initiated',
    PAYMENT_PENDING = 'payment_pending',
    PAYMENT_CONFIRMED = 'payment_confirmed',
    FULFILLMENT = 'fulfillment',
    COMPLETED = 'completed',
    FAILED = 'failed'
}

export enum PaymentType {
    FULL_PAYMENT = 'full_payment',
    INSTALLMENT = 'installment',
    PAY_LATER = 'pay_later'
}

export enum PaymentStatus {
    PENDING = 'pending',
    PAID = 'paid',
    OVERDUE = 'overdue',
    FAILED = 'failed'
}

export class PaymentPlan {
    constructor(
        public readonly id: string,
        public readonly orderId: string,
        public readonly amount: number,
        public readonly dueDate: Date,
        public readonly status: PaymentStatus,
        public readonly paymentMethod?: string,
        public readonly transactionId?: string,
        public readonly paidDate?: Date
    ) {
    }

    static create(params: PaymentPlanCreateParams): PaymentPlan {
        return new PaymentPlan(
            params.id,
            params.orderId,
            params.amount,
            params.dueDate,
            params.status || PaymentStatus.PENDING,
            params.paymentMethod,
            params.transactionId,
            params.paidDate
        );
    }

    markAsPaid(transactionId: string, paymentMethod: string): PaymentPlan {
        return new PaymentPlan(
            this.id,
            this.orderId,
            this.amount,
            this.dueDate,
            PaymentStatus.PAID,
            paymentMethod,
            transactionId,
            new Date()
        );
    }

    markAsOverdue(): PaymentPlan {
        return new PaymentPlan(
            this.id,
            this.orderId,
            this.amount,
            this.dueDate,
            PaymentStatus.OVERDUE,
            this.paymentMethod,
            this.transactionId,
            this.paidDate
        );
    }

    isOverdue(): boolean {
        return this.status === PaymentStatus.PENDING && this.dueDate < new Date();
    }
}

export interface OrderCreateParams {
    id: string;
    userId: string;
    productName: string;
    productId: string;
    productPrice: number;
    merchantName: string;
    shopName: string;
    paymentType: PaymentType;
    planDuration: number;
    planFrequency: string;
    phoneNumber: string;
    platform: string;
    userName: string;
    createdBy: string;
    orderNo?: number;
    productAdjustedPrice?: number;
    productTotalPrice?: number;
    imageUrl?: string | null;
    paymentPlan?: PaymentPlan[];
    keepMyPrice?: boolean;
    keepMyPriceFee?: number;
    status?: OrderStatus;
    state?: OrderState;
    thirdPartyInitiated?: boolean;
    initiatePayment?: boolean;
    isRequested?: boolean;
    campaignId?: string | null;
    createdTime?: Date;
    updatedTime?: Date;
}

export interface PaymentPlanCreateParams {
    id: string;
    orderId: string;
    amount: number;
    dueDate: Date;
    status?: PaymentStatus;
    paymentMethod?: string;
    transactionId?: string;
    paidDate?: Date;
}
export interface UserOrdersResponse {
  count: number;
  next: string;
  previous: null;
  results: Order[];
  summary: Summary;
}
export interface OrderExchangeLink {
  role: 'original' | 'replacement';
  exchange_id: string;
  status: string;
  settlement_mode: string;
  exchange_reason: string;
  price_delta: string;
  replacement_order_id?: string | null;
  replacement_order_number?: string | null;
  original_order_id?: string | null;
  original_order_number?: string | null;
  outstanding_charge?: {
    charge_id: string;
    amount: string;
    currency: string;
    status: string;
    allowed_payment_methods?: string[];
    payable: boolean;
    due_at?: string | null;
    payment_path?: string | null;
  } | null;
  balance_plan?: {
    plan_kind?: string;
    ui_capabilities?: {
      hide_pss_affordances?: boolean;
    };
  } | null;
}

export interface Order {
  id: string;
  order_number: string;
  created_at: Date;
  order_state: string;
  payment_method: string;
  payment_status: string;
  currency: string;
  product: Product;
  funding: Funding;
  pss_plan: PssPlan | null;
  delivery: Delivery;
  capabilities: Capabilities;
  exchange?: OrderExchangeLink | null;
}

export interface Capabilities {
  redeemable: boolean;
}

export interface Delivery {
  status: string;
  delivered_at: Date;
  tracking_number: string;
}

export interface Funding {
  type: string;
  state: string;
  target_amount: string;
  contributed_total: string;
  amount_left: string;
  progress_pct: number;
}


export interface PssPlan {
  status?: string;
  plan_started?: boolean;
  cancellation_cohort?: string | null;
  frequency?: string;
  duration_months: number;
  monthly_amount: string;
  payments_completed: number;
  payments_remaining: number;
  next_payment_date: Date;
}

export interface Summary {
  total_orders: number;
  active_pss_plans: number;
  completed_orders: number;
  pending_payments_count: number;
  total_spent: string;
  funding_state_breakdown: FundingStateBreakdown;
}

export interface FundingStateBreakdown {
  ongoing: number;
  defaulted: number;
  complete: number;
  cancelled?: number;
}
